var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M58.3245 316.231L312.823 196.704L268.275 118.094L58.3245 316.231Z","fill":"#7DD93F","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M255.572 95.4422L202.346 0L0 349L255.572 95.4422Z","fill":"#A0ED6D","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M323.915 219.177L242.78 253.2L397 349L323.915 219.177Z","fill":"#58B51A","key":2})]);
}

LogoIcon.defaultProps = {"width":"397","height":"349","viewBox":"0 0 397 349","fill":"none"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
